import { publicRoutes, useSessionStore } from '@/stores/session'
import { storeToRefs } from 'pinia'
import type { Router } from 'vue-router'

/**
 *
 * @param router: Router
 *
 * initializes sessionStore when the route is not public
 * This will trigger a login flow when the getUserInfo call returns 401 or 403
 * Also, it will prevent navigation until a user has been fetched
 */
export const initRouterGuardNew = (router: Router) => {
  router.beforeEach(async (to, _from) => {
    const sessionStore = useSessionStore()
    const { activeUser } = storeToRefs(sessionStore)
    if (publicRoutes.includes(to.name as string | undefined)) {
      return true
    } else {
      if (activeUser.value) {
        return true
      } else {
        await sessionStore.init(true)
        return true
      }
    }
  })
}
